import { parseCSVtoJSON } from "../csv/CSVtoJSON";

/* 
  Fetches Data from the CSV file in the S3 Bucket
  < input = selectedFileName >
  < output = data > 
*/

export async function fetchSnapshotCSV(S3, selectedFileName, repoDirectory) {
  // S3 bucket and csv key (prefix and filename)
  const bucket = process.env.REACT_APP_S3_BUCKET;
  const csvKey =
    localStorage.getItem("s3Link") +
    `/Forms/${repoDirectory}/` +
    selectedFileName +
    ".csv";

  try {
    // Fetch the specific CSV object from S3
    const s3Response = await S3.getObject({
      Bucket: bucket,
      Key: csvKey,
    }).promise();

    const tagResponse = await S3.getObjectTagging({
      Bucket: bucket,
      Key: csvKey,
    }).promise();

    //  // Extract status tag
    const statusTag = tagResponse.TagSet.find((tag) => tag.Key === "status");

    // Store the tag value in localStorage
    if (statusTag) {
      localStorage.setItem("snapshotStatus", statusTag.Value);
    }

    // CSV parameter is converted to string
    const parseCsvtoJson = await parseCSVtoJSON(s3Response.Body.toString());

    // Set local storage variables
    localStorage.setItem("initialFileName", selectedFileName);

    localStorage.setItem(
      "formattedDataArray",
      JSON.stringify(parseCsvtoJson.formattedDataArray)
    );

    //This data is retrieeved in the New Snapshot feature
    localStorage.setItem(
      "UpdatedDataArray",
      JSON.stringify(parseCsvtoJson.formattedDataArray)
    );

    localStorage.setItem(
      "companyNameEditable",
      parseCsvtoJson.CompanyNameEditable
    );

    localStorage.setItem("companyName", parseCsvtoJson.companyName);
    localStorage.setItem("selectedSnapshot", selectedFileName);

    // Console Testing
  } catch (error) {
    console.error("Error while Fetching Snapshots: ", error);
    return null;
  }
}
